import React from "react"

import { classNames } from "../../utils/class-names"
import * as styles from "./index.module.scss"

type Props = {
  children: React.ReactNode
  className?: string
  variant?: "header" | "headerWithHorizontalRule" | "v1" | "v2" | "badge"
}

const Caption = ({
  children,
  className,
  variant = "header",
  ...rest
}: Props) => {
  return (
    <div
      className={classNames(
        styles.caption,
        variant === "headerWithHorizontalRule" && styles.header,
        styles[variant],
        className,
      )}
      {...rest}
    >
      {variant === "headerWithHorizontalRule" ? (
        <span>{children}</span>
      ) : (
        children
      )}
    </div>
  )
}

export default Caption
